import React, { useState } from 'react';
// @ts-ignore
import styles from './ElectronicHealthCardContactInfoPreferredHealthProfessionalsWrapper.module.scss';
import { useNCZIContext } from '../../../../Services/NCZIContext';
import useNCZI from '../../../../Hooks/useNCZI';
import ElectronicHealthCardContactInfoPreferredHealthProfessionals from './ElectronicHealthCardContactInfoPreferredHealthProfessionals';
import NCZIEditPreferredHealthProfessionalModal from '../EditPreferredHealthProfessional/NCZIEditPreferredHealthProfessionalModal';

interface Props {
	patientIdentifier: string;
	setLoadingCommandId: (id: string) => void;
}

const ElectronicHealthCardContactInfoPreferredHealthProfessionalsWrapper: React.FC<
	Props
> = ({ patientIdentifier, setLoadingCommandId }) => {
	const [isAddOpen, setIsAddOpen] = useState<boolean>(false);
	const { patientSummaryContactData } = useNCZIContext();
	const { fetchPatientSummaryContactData } = useNCZI();

	const handleLoadPatientContactData = async () => {
		if (patientIdentifier) {
			const command = await fetchPatientSummaryContactData(patientIdentifier);
			if (command.id) {
				setLoadingCommandId(command.id);
			}
		}
	};
	const handleCloseAdd = async (needReload: boolean) => {
		setIsAddOpen(false);
		if (needReload) {
			await handleLoadPatientContactData();
		}
	};

	if (!patientSummaryContactData?.preferredHealthProfessionals) {
		return <></>;
	}

	return (
		<div className={styles.wrapper}>
			<ElectronicHealthCardContactInfoPreferredHealthProfessionals
				healthProfessionals={
					patientSummaryContactData.preferredHealthProfessionals
				}
				patientIdentifier={patientIdentifier}
				handleReloadData={handleLoadPatientContactData}
				handleAdd={() => setIsAddOpen(true)}
			/>
			<NCZIEditPreferredHealthProfessionalModal
				patientIdentifier={patientIdentifier}
				opened={isAddOpen}
				onClose={handleCloseAdd}
			/>
		</div>
	);
};

export default ElectronicHealthCardContactInfoPreferredHealthProfessionalsWrapper;
